<div class="upp-floor-plan__host" data-id="konva-floor-plan-host">
  <div class="upp-floor-plan__frame" #frame></div>
</div>
